import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-component-extradetail-popup',
  templateUrl: './component-extradetail-popup.component.html',
  styleUrls: ['./component-extradetail-popup.component.scss']
})
export class ComponentExtradetailPopupComponent implements OnInit {

  constructor( public dialogRef: MatDialogRef<ComponentExtradetailPopupComponent>,) { }

  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
